import styled from 'styled-components'
import { COLORS, SPACING } from 'utils'

export const SubHeaderContainer = styled.div`
  width: 100%;
  height: 6rem;
  background: ${COLORS.headerColor};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
export const ContentContainer = styled.div`
  padding-left: ${SPACING.spacing30};
  display: flex;
  flex-direction: column;
`
export const ImageContainer = styled.div`
  height: 100%;
  img {
    object-fit: fill;
  }
  max-width: 1100px;
  @media screen and (max-width: 1100px) {
    width: 50%;
    height: 5rem;
    img {
      object-fit: cover;
      object-position: left;
    }
  }
`
